import { CConfig } from "./CConfig";

class Resources{
	public id:string;
	public path:string;
	public type:string;

	constructor(id, path, type) {
		this.id = id;
		this.path = path;
		this.type = type;
	}
}

export class ResourcesList{
	public static RES:Array<Resources> = [
		// new Resources("mjCharacters", "images/mjCharacters.jpg", "bin"),
		// new Resources("mjCharacters@atlas0", "images/mjCharacters@atlas0.png", "image"),

		new Resources("mjCommon", "images/mjCommon.jpg?v="+CConfig.gameVersion, "bin"),
		new Resources("mjCommon@atlas0", "images/mjCommon@atlas0.png?v="+CConfig.gameVersion, "image"),

		new Resources("mjLoginScene", "images/mjLoginScene.jpg?v="+CConfig.gameVersion, "bin"),
		new Resources("mjLoginScene@atlas0", "images/mjLoginScene@atlas0.png?v="+CConfig.gameVersion, "image"),

		new Resources("mjLobbyScene", "images/mjLobbyScene.jpg?v="+CConfig.gameVersion, "bin"),
		new Resources("mjLobbyScene@atlas0", "images/mjLobbyScene@atlas0.png?v="+CConfig.gameVersion, "image"),
		new Resources("mjLobbyScene@atlas0_1", "images/mjLobbyScene@atlas0_1.png?v="+CConfig.gameVersion, "image"),
		new Resources("mjLobbyScene@atlas0_2", "images/mjLobbyScene@atlas0_2.png?v="+CConfig.gameVersion, "image"),

		new Resources("mjGameScene", "images/mjGameScene.jpg?v="+CConfig.gameVersion, "bin"),
		new Resources("mjGameScene@atlas0", "images/mjGameScene@atlas0.png?v="+CConfig.gameVersion, "image"),
		new Resources("mjGameScene@atlas0_1", "images/mjGameScene@atlas0_1.png?v="+CConfig.gameVersion, "image"),
		// new Resources("mjGameScene@atlas0_2", "images/mjGameScene@atlas0_2.png?v="+CConfig.gameVersion, "image"),
		// new Resources("mjGameScene@atlas0_3", "images/mjGameScene@atlas0_3.png?v="+CConfig.gameVersion, "image"),
		// new Resources("arblack", "images/arblack.fnt", "font"),
		//new Resources("arblack_0", "images/arblack_0.png", "image"),
		// new Resources("mjFont", "images/mjFont.fnt", "font"),
		// new Resources("mjFont_0", "images/mjFont_0.png", "image"),
		
		new Resources("s000", "snds/s000.mp3", "sound"),
		new Resources("s001", "snds/s001.mp3", "sound"),
		new Resources("s002", "snds/s002.mp3", "sound"),
		new Resources("s003", "snds/s003.mp3", "sound"),
		new Resources("s004", "snds/s004.mp3", "sound"),
		new Resources("s005", "snds/s005.mp3", "sound"),
		new Resources("s006", "snds/s006.mp3", "sound"),
		new Resources("s007", "snds/s007.mp3", "sound"),
		new Resources("s008", "snds/s008.mp3", "sound"),
		new Resources("s009", "snds/s009.mp3", "sound"),
		new Resources("s010", "snds/s010.mp3", "sound"),
		new Resources("s011", "snds/s011.mp3", "sound"),
		new Resources("s012", "snds/s012.mp3", "sound"),
		new Resources("s013", "snds/s013.mp3", "sound"),
		new Resources("s014", "snds/s014.mp3", "sound"),

		new Resources("act00", "snds/thi.mp3", "sound"),
		new Resources("act01", "snds/pon.mp3", "sound"),
		new Resources("act02", "snds/gun.mp3", "sound"),
		new Resources("act03", "snds/ting.mp3", "sound"),
		new Resources("act04", "snds/hu.mp3", "sound"),
		new Resources("act05", "snds/zimo.mp3", "sound"),

		new Resources("v001", "snds/v001.mp3", "sound"),
		new Resources("v002", "snds/v002.mp3", "sound"),
		new Resources("v003", "snds/v003.mp3", "sound"),
		new Resources("v004", "snds/v004.mp3", "sound"),
		new Resources("v005", "snds/v005.mp3", "sound"),
		new Resources("v006", "snds/v006.mp3", "sound"),
		new Resources("v007", "snds/v007.mp3", "sound"),
		new Resources("v008", "snds/v008.mp3", "sound"),
		new Resources("v009", "snds/v009.mp3", "sound"),
		new Resources("v010", "snds/v010.mp3", "sound"),
		new Resources("v011", "snds/v011.mp3", "sound"),
		new Resources("v012", "snds/v012.mp3", "sound"),
		new Resources("v013", "snds/v013.mp3", "sound"),
		new Resources("v014", "snds/v014.mp3", "sound"),
		new Resources("v015", "snds/v015.mp3", "sound"),
		new Resources("v016", "snds/v016.mp3", "sound"),

		new Resources("voc010", "snds/voc000.mp3", "sound"),
		new Resources("voc011", "snds/voc001.mp3", "sound"),
		new Resources("voc012", "snds/voc002.mp3", "sound"),
		new Resources("voc013", "snds/voc003.mp3", "sound"),
		new Resources("voc014", "snds/voc004.mp3", "sound"),
		new Resources("voc015", "snds/voc005.mp3", "sound"),
		new Resources("voc016", "snds/voc006.mp3", "sound"),
		new Resources("voc017", "snds/voc007.mp3", "sound"),
		new Resources("voc018", "snds/voc008.mp3", "sound"),
		new Resources("voc020", "snds/voc009.mp3", "sound"),
		new Resources("voc021", "snds/voc010.mp3", "sound"),
		new Resources("voc022", "snds/voc011.mp3", "sound"),
		new Resources("voc023", "snds/voc012.mp3", "sound"),
		new Resources("voc024", "snds/voc013.mp3", "sound"),
		new Resources("voc025", "snds/voc014.mp3", "sound"),
		new Resources("voc026", "snds/voc015.mp3", "sound"),
		new Resources("voc027", "snds/voc016.mp3", "sound"),
		new Resources("voc028", "snds/voc017.mp3", "sound"),
		new Resources("voc030", "snds/voc018.mp3", "sound"),
		new Resources("voc031", "snds/voc019.mp3", "sound"),
		new Resources("voc032", "snds/voc020.mp3", "sound"),
		new Resources("voc033", "snds/voc021.mp3", "sound"),
		new Resources("voc034", "snds/voc022.mp3", "sound"),
		new Resources("voc035", "snds/voc023.mp3", "sound"),
		new Resources("voc036", "snds/voc024.mp3", "sound"),
		new Resources("voc037", "snds/voc025.mp3", "sound"),
		new Resources("voc038", "snds/voc026.mp3", "sound"),
		new Resources("voc040", "snds/voc027.mp3", "sound"),
		new Resources("voc041", "snds/voc028.mp3", "sound"),
		new Resources("voc042", "snds/voc029.mp3", "sound"),
		new Resources("voc043", "snds/voc030.mp3", "sound"),
		new Resources("voc044", "snds/voc031.mp3", "sound"),
		new Resources("voc045", "snds/voc032.mp3", "sound"),
		new Resources("voc046", "snds/voc033.mp3", "sound"),
	];
}